/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedOrganizationRequest
 */
export interface APIPatchedOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedOrganizationRequest
     */
    billingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedOrganizationRequest
     */
    shippingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedOrganizationRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedOrganizationRequest
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedOrganizationRequest
     */
    website?: string;
}

/**
 * Check if a given object implements the APIPatchedOrganizationRequest interface.
 */
export function instanceOfAPIPatchedOrganizationRequest(value: object): value is APIPatchedOrganizationRequest {
    return true;
}

export function APIPatchedOrganizationRequestFromJSON(json: any): APIPatchedOrganizationRequest {
    return APIPatchedOrganizationRequestFromJSONTyped(json, false);
}

export function APIPatchedOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'billingAddress': json['billing_address'] == null ? undefined : json['billing_address'],
        'shippingAddress': json['shipping_address'] == null ? undefined : json['shipping_address'],
        'name': json['name'] == null ? undefined : json['name'],
        'vatNumber': json['vat_number'] == null ? undefined : json['vat_number'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function APIPatchedOrganizationRequestToJSON(value?: APIPatchedOrganizationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'billing_address': value['billingAddress'],
        'shipping_address': value['shippingAddress'],
        'name': value['name'],
        'vat_number': value['vatNumber'],
        'website': value['website'],
    };
}

